var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from "lodash/get";
import { API_METHODS_ENUM } from "../../httpService";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { LoaderState } from "../../store/actions/loader.actions";
import { deriveMethodName, fetchUserEntities, getUserEntity } from "../../store/actions/response.actions";
import { connect } from "../../store/connect";
import { getAuthEntityManager } from "../models/AuthModelManager";
import keyBy from "lodash/keyBy";
var createEntityConnect = function (arg) {
    var entityName = arg.entityName, columnHeaders = arg.columnHeaders;
    var mapStateToProps = function (state) {
        var _a, _b, _c;
        var cacheKey = deriveMethodName(API_METHODS_ENUM.FETCH_USER_ENTITY, { cacheParams: true }, { entity: entityName });
        var loadingState = new LoaderState(state.loaderReducer, { keys: [cacheKey] });
        return {
            entities: getResponseManager((_a = getUserEntity(state.responseReducer, { entity: entityName })) === null || _a === void 0 ? void 0 : _a.response).entities(),
            isLoading: loadingState.isLoading(),
            hasInitialized: loadingState.hasInitialized(),
            columns: (_c = state.courseReducer[(_b = arg.columnConfiguration) !== null && _b !== void 0 ? _b : '']) !== null && _c !== void 0 ? _c : null,
        };
    };
    var mergeProps = function (state, dispatch, ownProps) {
        var _a, _b;
        var columnConfigurationByKey = keyBy(columnHeaders, 'key');
        return __assign(__assign(__assign({ entityName: entityName, isLoading: state.isLoading, hasInitialized: state.hasInitialized, records: state.entities && get(getAuthEntityManager(state.entities), entityName) }, dispatch), ownProps), { columnHeaders: (_b = (_a = state.columns) === null || _a === void 0 ? void 0 : _a.map(function (column) { return columnConfigurationByKey[column]; })) !== null && _b !== void 0 ? _b : columnHeaders });
    };
    var mapDispatch = function (dispatch) { return ({
        fetchEntities: function (cancelToken) { return dispatch(fetchUserEntities(entityName, cancelToken)); }
    }); };
    return connect(mapStateToProps, mapDispatch, mergeProps);
};
export default createEntityConnect;
